import { Component, Inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { InputGeneralTextComponent } from '../../inputs/input-general-text/input-general-text.component';
import { ModalCommentInterface } from '../../models/components-general/modal-genearal.model';

@Component({
  selector: 'app-modal-general-comment',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, InputGeneralTextComponent],
  templateUrl: './modal-general-comment.component.html',
})
export class ModalGeneralCommentComponent {
  public formControlGeneral: FormControl = new FormControl('', [Validators.required]);
  constructor(
    public dialogRef: MatDialogRef<ModalGeneralCommentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModalCommentInterface,
  ) {
    this.formControlGeneral.addValidators(Validators.required);
  }

  public closeModal(): void {
    this.dialogRef.close(null);
  }

  public emptyComment(): void {
    this.dialogRef.close(false);
  }

  public emitValue(): void {
    this.dialogRef.close(this.formControlGeneral.value);
  }
}
